import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

momentDurationFormatSetup(moment);

class Timer extends Component {
	static defaultProps = {
		isTimerActive: false,
		startTime: null,
		delay: 1,
	};

	static propTypes = {
		isTimerActive: PropTypes.bool.isRequired,
		startTime: PropTypes.string,
		delay: PropTypes.number,
	};

	constructor(props) {
		super(props);
		this.state = {
			time: 0,
			start: 0,
			timeFormat: '00:00:00:00',
		};

		this.timer = null;
	}

	componentDidMount() {
		const { isTimerActive, startTime, type } = this.props;
		if (type !== 'replay') {
			const dateStartTime = startTime
				? moment(startTime).format('X')
				: moment().format('X');
			this.setState({ time: moment().format('X') - dateStartTime });
			if (isTimerActive && startTime) {
				this.startTimer();
			}
		}
	}

	componentWillUnmount() {
		clearInterval(this.timer);
	}

	tick = () => {
		this.setState({ time: this.state.time + 1 });
	};

	startTimer() {
		clearInterval(this.timer);
		this.timer = setInterval(this.tick, 1000);
	}

	getReplayTime = sec =>
		moment()
			.startOf('day')
			.seconds(sec)
			.format('HH:mm:ss');
	render() {
		const { time } = this.state;
		const { isTimerActive, type, replaySec } = this.props;
		if (type === 'replay') {
			return <p className="timer">{this.getReplayTime(replaySec)}</p>;
		}
		return isTimerActive ? (
			<p className="timer">{this.getReplayTime(time)}</p>
		) : null;
	}
}

export default Timer;



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/components/timer/index.js